export enum ReportType {
  USER_FOOD_PREFERENCES = 'users-food-preferences',
  SURVEYS_AND_OBSERVANCE = 'surveys-observance-follow-up',
  RECIPE_DATABASE_PERFORMANCE = 'recipe-database-performance',
}
